<template>
    <div class="bg-neutral-white">
      <CCol sm="12" xs="6" class="text-right">
        <h5 class="custom-18px poppin-font mt-0 text-center" style="padding-top: 40px;">
          <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            <span style="margin-top:20px">Social Media Link</span>
        </h5>
      </CCol>
      <div style="clear:both"></div>
      <br /><br />
      <CCol sm="12">
        <div class="m-0 justify-content-center align-items-center">
          <div class="m-0">
            <span>
              <img src="../assets/img/whatsapp.png" style="width: 20px; height: 20px;" />
              <label class="custom-font-setting ml-2">Whatsapp</label> 
              <div class="float-right">
                <label class="custom-14px"> +62895619057476 </label>
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToWhatsapp()" />
              </div> 
            </span>

            <hr />
              
            <span>
              <img src="../assets/img/telegram.png" style="width: 20px; height: 20px;" />
              <label class="custom-font-setting ml-2">Telegram</label> 
              <div class="float-right">
                <label class="custom-14px"> id : Sititirtadinar </label>
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToTelegram()" />
              </div> 
            </span>

            <br /><br />
          </div>
          
          <br /><br /> <br /><br /> <br /><br />
        </div>
      
              
      
      
      
      </CCol>
    </div>
  </template>
  
  
  <script>
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  import {
      Hooper,
      Slide,
      Navigation as HooperNavigation,
      Pagination as HooperPagination,
  } from "hooper";
  
  import "hooper/dist/hooper.css";
  export default ({
      components: {
          Hooper,
          Slide,
          HooperNavigation,
          HooperPagination,
          MainlayoutBottom,
      },
      data() {
          return {
              isLanguagePopupVisible: false,
              code: ["", "", "", ""],
              hooperSettings1: {
                  hideArrows: true,
              },
  
          }
  
      },
      methods: {
          GoToPrevious() {
              this.$router.go(-1);
          },
  
        //   GoToLogin() {
        //       // Close the popup and backdrop
        //       this.$router.push("/RegisterHomepage");
        //   },
  
        //   GoToChangePassword() {
        //       // Close the popup and backdrop
        //       this.$router.push("/ChangePassword");
        //   },
        //   submitVerification() {
        //       const verificationCode = this.code.join(""); // Concatenate the digits
        //       console.log("Verification Code:", verificationCode);
  
        //       this.popupSuccess = true;
  
        //       // Add your logic to handle the verification code
        //   },
  
        GoToWhatsapp() {
          this.$router.push("/EditWhatsapp");
        },

        GoToTelegram() {
          this.$router.push("/EditTelegram");
        },
  
      }
  })
  </script>
  
  <style scoped>
  body {
      top: 0 !important;
      font-family: 'Poppins', sans-serif;
  }
  </style>